const pageBreakingRules = {
  pageBreakingRules: {
    text: "Данный тур был снят с публикации за нарушение правил платформы",
  },
};

export { pageBreakingRules };
